import { Directive, ElementRef, HostListener, input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appTruncate]'
})
export class TruncateDirective {
  appTruncate = input<number>(2); // default 2 lines
  private expanded = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.applyClamp();
  }

  @HostListener('click')
  toggle() {
    this.expanded = !this.expanded;
    if (this.expanded) {
      this.removeClamp();
    } else {
      this.applyClamp();
    }
  }

  private applyClamp() {
    this.renderer.setStyle(this.el.nativeElement, '-webkit-line-clamp', this.appTruncate().toString());
    this.renderer.setStyle(this.el.nativeElement, 'display', '-webkit-box');
    this.renderer.setStyle(this.el.nativeElement, '-webkit-box-orient', 'vertical');
    this.renderer.setStyle(this.el.nativeElement, 'overflow', 'hidden');
    this.renderer.setStyle(this.el.nativeElement, 'cursor', 'pointer');
  }

  private removeClamp() {
    this.renderer.removeStyle(this.el.nativeElement, '-webkit-line-clamp');
    this.renderer.removeStyle(this.el.nativeElement, 'display');
    this.renderer.removeStyle(this.el.nativeElement, '-webkit-box-orient');
    this.renderer.removeStyle(this.el.nativeElement, 'overflow');
  }
}
